<template>
  <div class="Engineering_crumbs">
    <div class="fac flex flex_ai_center">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
        <i class="el-icon-location floatLeft"></i>
        <router-link tag='a' :to="'/'" class="floatLeft refreshPage">首页</router-link>
        <span class="floatLeft">/</span>
        <el-breadcrumb-item><span class="refreshPage" @click="goRentInformationDetails">租赁企业列表/</span><span class="refreshPage" @click="refreshPage">租赁企业详情</span></el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <p class="enterpriseParticulars">傻逼的骄傲笔记本大数据看不见的的</p>
    <p class="enterpriseFontS12">能吃苦的就是你不放大看速度能否快速电脑客服那棵树的女粉丝看到你发开始的年份</p>
  </div>
</template>
<script>

export default {
  name: 'Breadcrumb',
  components: { },
  data () {
    return {}
  },
  computed: {},
  methods: {
    goRentInformationDetails () {
      this.$router.push({ path: `/inquiryList/` })
    },
    refreshPage () {
      window.location.reload()
    }
  },
  watch: {},
  created () {},
  mounted () {}
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
 /* 面包屑 */
  .Engineering_crumbs {
    width: 1170px;
    margin: 0 auto;
    overflow: hidden;
    div.fac {
        height: 60px;
    }
    p.enterpriseParticulars {
        font-size: 18px;
        font-weight: bolder;
        margin-bottom: 10px;
    }
    p.enterpriseFontS12 {
        font-size: 12px;
        color: #929292;
        margin-bottom: 20px;
    }
  }
.el-icon-location {
    color: #FF8B00;
    margin-right: 5px;
}
.refreshPage:hover{
    color: #FF8B00;
    cursor: pointer;
}
.floatLeft {
    float: left;
}
</style>
